import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { ToastContainer, toast } from 'react-toastify';
import { Link ,useLocation, useNavigate} from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunks";

// import logoLight from "../../assets/images/logo-light.png";
import snwhite from "../../assets/images/sn_white_logo.avif";

import { createSelector } from 'reselect';
//import images 
import { authenticateWithOdoo } from "../../utils/api";
import { baseURL } from "../../utils/usermanagement";
import { googleOAuthService } from "../../services/googleOAuthService";

import { layoutModeTypes } from "../../Components/constants/layout";
import logoDark from '../../assets/images/exiaLogo_dark.png';
import logoLight from '../../assets/images/exiaLogo_light.png';
const Login = (props) => {
    const dispatch = useDispatch();
    
    // Separate selectors for different state slices
    const selectLoginState = (state) => state;
    const loginpageData = createSelector(
        selectLoginState,
        (state) => ({
            user: state.Account.user,
            error: state.Login.error,
            loading: state.Login.loading,
            errorMsg: state.Login.errorMsg,
        })
    );
    
    // Separate selector for layout state
    const selectLayoutState = (state) => state.Layout;
    const layoutData = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutModeType: layout.layoutModeType,
        })
    );
    
    // Inside your component
    const {
        user, error, loading, errorMsg
    } = useSelector(loginpageData);
    
    const { layoutModeType } = useSelector(layoutData);
    const location = useLocation();
    const navigate = useNavigate();
    const [userLogin, setUserLogin] = useState([]);
    // const [loading, setLoading] = useState(false);
    const [passwordShow, setPasswordShow] = useState(false);

    const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });

    // useEffect(() => {
    //     if (user && user) {
    //         const updatedUserData = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? user.multiFactor.user.email : user.user.email;
    //         const updatedUserPassword = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? "" : user.user.confirm_password;
    //         setUserLogin({
    //             email: updatedUserData,
    //             password: updatedUserPassword
    //         });
    //     }
    // }, [user]);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: userLogin.email || '',
            password: userLogin.password || '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values) => {
            // dispatch(loginUser(values, props.router.navigate));
            // setLoading(true);
            try {
                const response = await authenticateWithOdoo(values); 
                if (response.success) {
                    // Handle successful login
                    // console.log('Login Successful:', response);
                    const token = response.token;
                    const refreshToken = response.refreshToken;
                    const profile_picture_url = response.user.profile_picture_url;
                    const avatar_url = response.user.profile_photo_url_object.profile_url;
                    debugger
                    const user = {
                        id: response.user.id,
                        name: response.user.name,
                        profile_picture_url: profile_picture_url?`${baseURL}/file/profile/image/${profile_picture_url}`:`${baseURL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`,
                        role: response.user.role,
                        company_id: response.user.company_id,
                        avatar_url: avatar_url?`${baseURL}/file/avatar/${avatar_url}`:`${baseURL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`,
                      };
                      
                    if (token) {
                        // console.log('token', token, 'refreshToken', refreshToken, 'user', user);
                        sessionStorage.setItem("authToken", token);
                        sessionStorage.setItem("refreshToken", refreshToken);
                        sessionStorage.setItem("user", JSON.stringify(user));
                        const redirectPath = location.state?.from || "/home";
                        props.router.navigate(redirectPath); // Redirect to a protected page
                    } else {
                        errornotify("No token returned") 
                        console.error("No token returned");
                    }
                } else if (response.status === 404) {
                    // If user not found, guide to registration
                    props.history.push('/register');
                } else { 
                    errornotify(response.response.data.error) 
                    // setError(response.message);
                    console.error("Error:",response.message);
                }
            } catch (err) {
                //  
                errornotify(err) 
                console.error('Login failed. Please try again.Error', err);
                // setError('Login failed. Please try again.');
            }
            // setLoading(false);
        }
    });

    // const signIn = type => {
    //     dispatch(socialLogin(type, props.router.navigate));
    // };

    //handleTwitterLoginResponse
    // const twitterResponse = e => {}

    //for facebook and google authentication
    const socialResponse = type => {
        signIn(type);
    };


    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);
    // Remove the hardcoded mode logic and use the actual layout mode from Redux
    const mode = layoutModeType || layoutModeTypes.LIGHTMODE;

    document.title = "SignIn | SeedNations - SeedNation Website";
    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <Container>
                        <ToastContainer />
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                        {/* Logo logic: Light mode shows light logo, Dark mode shows dark logo */}
                                        <img src={mode === layoutModeTypes.LIGHTMODE ? logoLight : logoDark} alt="" height="200" />
                                        </Link>
                                    </div>
                                    {/* <p className="mt-3 fs-15 fw-medium">Premium Admin </p> */}
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <div className="mt-4">
                                    <div className="p-4">
                                        {/* <div className="text-center mt-2">
                                            <h5 className="text-primary">Welcome Back LOGIN!</h5>
                                            <p className="text-muted">Sign in to continue to SeedNations.</p>
                                        </div> */}
                                        {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                action="#">

                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">Email</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password && validation.errors.password ? true : false
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={() => setPasswordShow(!passwordShow)} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                                                    </div>
                                                </div>

                                                <div className="form-check">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                                </div>

                                                <div className="mt-4">
                                                    <Button   disabled={error ? null : loading ? true : false} style={{backgroundColor:'#24F4C0',color:'#000'}} className="btn  w-100" type="submit">
                                                        {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : null}
                                                        LOG IN
                                                    </Button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <div className="signin-other-title">
                                                        <h5 className="fs-13 mb-4 title">Sign In with</h5>
                                                    </div>
                                                    <div>
                                                        <Link
                                                            to="#"
                                                            className="btn btn-primary btn-icon me-1"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                socialResponse("facebook");
                                                            }}
                                                            >
                                                            <i className="ri-facebook-fill fs-16" />
                                                        </Link>
                                                        <Link
                                                            to="#"
                                                            className="btn btn-danger btn-icon me-1"
                                                            onClick={async (e) => {
                                                                e.preventDefault();
                                                                try {
                                                                    console.log('Initiating Google OAuth login...');
                                                                    await googleOAuthService.initiateGoogleLogin();
                                                                } catch (error) {
                                                                    console.error('Google OAuth login error:', error);
                                                                    errornotify('Google OAuth login failed. Please try again.');
                                                                }
                                                            }}
                                                            >
                                                            <i className="ri-google-fill fs-16" />
                                                        </Link>
                                                        <Button color="dark" className="btn-icon"><i className="ri-github-fill fs-16"></i></Button>{" "}
                                                        <Button color="info" className="btn-icon"><i className="ri-twitter-fill fs-16"></i></Button>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-4 text-center">
                                    <p className="mb-0">Don't have an account ? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Signup </Link> </p>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);